import classNames from "classnames";
import styles from "./Content.module.css";
import { type PropsWithChildren, type JSX } from "react";

type ContentProps = PropsWithChildren<{
  background?: "default" | "gray";
  withPadding?: boolean;
  withMargin?: boolean;
  isCentered?: boolean;
  reducedGap?: boolean;
}>;

const Content = (props: ContentProps): JSX.Element => {
  const {
    children,
    background = "default",
    withPadding = false,
    withMargin = false,
    isCentered = false,
    reducedGap = false,
  } = props;

  const contentClassNames = classNames(styles.content, {
    [styles[background]]: background !== "default",
    [styles.withPadding]: withPadding,
    [styles.withMargin]: withMargin,
    [styles.isCentered]: isCentered,
    [styles.reducedGap]: reducedGap,
  });

  return <div className={contentClassNames}>{children}</div>;
};

export { Content };
